import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlus, FaMinus, FaQuestionCircle } from 'react-icons/fa';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'नाशेरा गावाचा PIN कोड काय आहे?',
      answer: 'नाशेरा गावाचा PIN कोड ४०१६०४ आहे.'
    },
    {
      question: 'नाशेरा गावाची लोकसंख्या किती आहे?',
      answer: '२०११ च्या जनगणनेनुसार नाशेरा गावाची एकूण लोकसंख्या १०८० आहे. यात ५३८ पुरुष आणि ५४२ महिला आहेत.'
    },
    {
      question: 'नाशेरा गाव कुठे आहे?',
      answer: 'नाशेरा हे महाराष्ट्रातील पालघर जिल्ह्याच्या मोखाडा तालुक्यात वसलेले गाव आहे.'
    },
    {
      question: 'नाशेरा ग्रामपंचायतचे सरपंच कोण आहेत?',
      answer: 'सौ. सरस्वती शेषराव भोळे या नाशेरा ग्रामपंचायतच्या सरपंच आहेत.'
    },
    {
      question: 'नाशेरा ग्रामपंचायतचे सचिव कोण आहेत?',
      answer: 'श्री. रामचंद्र माधव राजपूत हे नाशेरा ग्रामपंचायतचे सचिव आहेत.'
    },
    {
      question: 'ग्रामपंचायत कार्यालयाची वेळ काय आहे?',
      answer: 'ग्रामपंचायत कार्यालय सोमवार ते शुक्रवार सकाळी १०:०० ते सायंकाळी ५:०० वाजेपर्यंत उघडे असते.'
    },
    {
      question: 'नाशेरा ग्रामपंचायतशी संपर्क कसा करावा?',
      answer: 'ईमेल: gpnasherapsmokhada@gmail.com | फोन: +91 7620 135 257 | पत्ता: ग्रामपंचायत कार्यालय, नाशेरा, तालुका: मोखाडा | जिल्हा: पालघर, महाराष्ट्र - ४०१६०४'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="services-section">
      <h2 className="section-title"><span>वारंवार विचारले जाणारे प्रश्न</span></h2>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {faqs.map((faq, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.08 }}
            style={{
              background: 'white',
              marginBottom: '1rem',
              borderRadius: '12px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
              overflow: 'hidden',
              border: openIndex === index ? '2px solid #138808' : '2px solid #e8f5e9'
            }}
          >
            <div
              onClick={() => toggleFAQ(index)}
              style={{
                padding: '1.4rem 1.8rem',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: openIndex === index ? '#e8f5e9' : 'white',
                transition: 'all 0.3s'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1 }}>
                <FaQuestionCircle style={{ color: '#138808', fontSize: '1.2rem', flexShrink: 0 }} />
                <h3 style={{ margin: 0, fontSize: '1.05rem', color: '#2c3e50', fontWeight: '600' }}>
                  {faq.question}
                </h3>
              </div>
              <div style={{ color: '#138808', fontSize: '1.1rem', marginLeft: '1rem', flexShrink: 0 }}>
                {openIndex === index ? <FaMinus /> : <FaPlus />}
              </div>
            </div>
            <AnimatePresence>
              {openIndex === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  style={{ overflow: 'hidden' }}
                >
                  <div style={{
                    padding: '1.2rem 1.8rem 1.5rem 3.8rem',
                    color: '#555',
                    lineHeight: '1.8',
                    fontSize: '1rem',
                    borderTop: '1px solid #e8f5e9'
                  }}>
                    {faq.answer}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
